import { create } from 'zustand';

interface UIState {
  hideHeader: boolean;
  setHideHeader: (hidden: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  hideHeader: false,
  setHideHeader: (hidden) => set({ hideHeader: hidden }),
}));
